
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/especialistas/todos",
      function () {
        return require("private-next-pages/especialistas/todos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/especialistas/todos"])
      });
    }
  